/* eslint-disable office-addins/no-context-sync-in-loop */
/* global console PowerPoint */

export async function parseShapes(slideId, gridd) {
  const diffs = [];
  console.log("Startup: parsing shapes for gridd", { slideId, gridd });
  try {
    await PowerPoint.run(async (context) => {
      const shapes = context.presentation.slides.getItem(slideId).shapes;
      shapes.load({ name: true });
      await context.sync();
      const textBoxes = [];

      shapes.items.forEach(async (shape) => {
        if (shape.name.startsWith("Gridd_")) {
          const coord = shape.name.slice(shape.name.lastIndexOf("_") + 1);
          const indices = coord.split("x");
          if (indices.length === 2) {
            const x = parseInt(indices[0]);
            const y = parseInt(indices[1]);
            const cell = gridd.cells[x][y];

            const tb = {
              coord,
              indices,
              x,
              y,
              cell,
              id: shape.id,
            };
            textBoxes.push(tb);
          }
        }
      });

      for (let i = 0; i < textBoxes.length; i++) {
        const tb = textBoxes[i];
        const shape = shapes.getItem(tb.id);
        shape.load("textFrame/hasText");
        await context.sync();
        if (shape.textFrame.hasText) {
          shape.load("textFrame/textRange/text");
          await context.sync();
          const shapeText = shape.textFrame.textRange.text;
          if (tb.cell?.text !== shapeText) {
            diffs.push({ ...tb, shapeText });
          }
        }
      }

      console.log("Startup: diffs collected", { textBoxes, diffs });
    });
  } catch (error) {
    console.error("Startup: error while processing PPT shapes", error);
  }

  return diffs;
}
